import Axios from "axios";
import { useContext, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import DashboardContext from "Context";
import ConfirmModal from "components/ConfirmModal";
import TableEditB2BWorker from "./TableEditB2BWorker";
import toaster from "helper/toaster";
import { Skeleton } from "antd";

/**
 * این کامپوننت برای نمایش مدال افزودن نیرو است
 * در جدول سفارشات و نیرو ها است
 */
const ModalEditB2BWorker = ({ showitem, handleCloseMoudal, id }) => {
  const { sideBardata, authentication, urldashboard } =
    useContext(DashboardContext);
  const [loading, setLoading] = useState(false);
  const [localReload, setReload] = useState(false);
  const [shouldShow, setShouldShow] = useState(false);
  const [loadingFrom, setLoadingFrom] = useState(false);
  const [arryactions, setArryactions] = useState([]);
  const [customerData, setCustomerData] = useState([]);

  const dataFeching = async () => {
    setLoading(true);
    try {
      const res = await Axios.post(
        `${urldashboard}/workerOrderSchedule/get`,
        JSON.stringify({ orderScheduleId: id }),
        {
          headers: {
            Authorization: authentication,
            "Content-Type": "application/json; charset=utf-8 ",
          },
        }
      );
      // eslint-disable-next-line no-unused-expressions
      const data = await res.data.data;
      setCustomerData(data);
      setLoading(false);
    } catch (error) {
      if (error.message === "Network Error") {
        setLoading(false);
        return toaster.error(
          "اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید."
        );
      }
      setLoading(false);
      toaster.error(error.response?.data?.message);
    }
  };

  useEffect(() => {
    dataFeching();

    if (sideBardata) {
      sideBardata.map((item) => {
        item.controllers.filter((find) => {
          if (`/${find.controller}` === "/WorkerOrderSchedule") {
            setArryactions(find.actions);

            return find;
          }
        });
      });
    }
    return () => {};
  }, [localReload]);

  const handelSubmitB2BWorker = async () => {
    setLoadingFrom(true);

    try {
      const res = await Axios.post(
        `${urldashboard}/workerorderschedule/UpdateB2BWorkersType`,
        JSON.stringify({ orderScheduleId: id }),
        {
          headers: {
            Authorization: authentication,
            "Content-Type": "application/json",
          },
        }
      );
      toaster.success(res?.data?.message);
    } catch (error) {
      toaster.error(error?.response?.data?.message);
    }
    setLoadingFrom(false);
  };

  return (
    <Modal show={showitem} onHide={handleCloseMoudal} size={"lg"}>
      <Modal.Header>
        <Modal.Title style={{ width: "100%" }}>
          {loading ? (
            <Skeleton.Input size='large' block style={{ width: "50%" }} />
          ) : (
            <>
              <div>
                ویرایش ورود و خروج و پایان کار
                {customerData?.length > 0 && (
                  <span style={{ color: "#898989" }}>
                    {` (سفارش ${customerData[0]?.trackingCode} - ${customerData[0]?.customerName})`}
                  </span>
                )}
              </div>
              {customerData?.length > 0 && (
                <>
                  <div style={{ color: "#898989", marginTop: "1rem" }}>
                    {`${customerData[0]?.customerAddress} - بخش ${customerData[0]?.sectionName}`}
                  </div>
                  <div style={{ color: "#898989", marginTop: "1rem" }}>
                    امکانات سفارش:
                    {customerData[0]?.facilities ? (
                      <span style={{ color: "#000000" }}>
                        {` ${customerData[0]?.facilities}`}
                      </span>
                    ) : (
                      " موجود نیست"
                    )}
                  </div>
                </>
              )}
            </>
          )}
        </Modal.Title>
        <i
          className='fa fa-times mr-auto'
          style={{ fontSize: "16px", cursor: "pointer" }}
          onClick={handleCloseMoudal}
          aria-hidden='true'
        ></i>
      </Modal.Header>

      <Modal.Body>
        <TableEditB2BWorker
          urldata='/WorkerOrderSchedule'
          reloadAvailableWorkes={() => setReload(!localReload)}
          reload={localReload}
          isform
          itemname='orderScheduleId'
          params={id}
          page='1'
          pageSiz='50'
          arryactions={arryactions}
          close={handleCloseMoudal}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          disabled={loadingFrom}
          variant='danger'
          className='ml-auto'
          onClick={handleCloseMoudal}
        >
          بستن
        </Button>
        <Button
          disabled={loadingFrom}
          onClick={() => setShouldShow(true)}
          variant='success'
        >
          {loadingFrom ? (
            <i className='fa fa-spinner fa-pulse fa-fw'></i>
          ) : (
            "ثبت شروع و پایان کار"
          )}
        </Button>
      </Modal.Footer>
      <ConfirmModal
        shouldShow={shouldShow}
        setShouldShowShow={setShouldShow}
        onOkFn={handelSubmitB2BWorker}
        modalTitle='ثبت شروع و پایان کار'
        modalQuestion='آبا از انجام عمل ثبت مطمئن هستید؟'
      />
    </Modal>
  );
};

export default ModalEditB2BWorker;
